/**
 * 文字列チェックなど
 *
 **/
export class StringUtils {
  /**
   * 文字列の半角文字のみかチェック
   * REST-APIのURLパラメータで使用できない ?/\# の4文字はNGとする
   *
   * @param {string} value : 判定する文字列
   *
   * @returns {bool}
   */
  static isHalfWidth(value) {
    if (value.match(/^[a-zA-Z0-9!-"$-.:->@[\]^-`{-~\s]*$/)) {
      return true
    } else {
      return false
    }
  }
}
